import { useEffect, useState } from 'react';
import { Button, Card, Form, Modal } from 'react-bootstrap';

const AgeGroupProductsAddModal = ({ show, handleClose, handleAddProduct, parsingDataEdit}) => {
    const [ageGroupProduct, setAgeGroupProduct] = useState({
        name: ''
    });

    useEffect(() => {
        if (parsingDataEdit) {
            setAgeGroupProduct({
                name: parsingDataEdit.name
            });
        } else {
            setAgeGroupProduct({ name: '' });
        }
    }, [parsingDataEdit]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAgeGroupProduct({ ...ageGroupProduct, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (parsingDataEdit != null) {
            handleAddProduct({ ...parsingDataEdit, ...ageGroupProduct });
        } else {
            handleAddProduct(ageGroupProduct);
        }

        setAgeGroupProduct({ name: '' });
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Add New Age Group Product</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={ageGroupProduct.name}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit">
                        Submit
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AgeGroupProductsAddModal;